import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const FlagIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M16 17c-1.7 0-3-.5-4.4-1-1.2-.6-2.3-1-3.6-1-2.4 0-3.3.7-3.3.7a1 1 0 0 1-1.1.2A1 1 0 0 1 3 15V3c0-.3.1-.5.3-.7C3.5 2 4.8 1 8 1c1.7 0 3 .5 4.4 1 1.2.5 2.3 1 3.6 1 2.4 0 3.3-.7 3.3-.7a1 1 0 0 1 1.1-.2c.4.2.6.5.6.9v12c0 .3-.1.5-.3.7-.2.2-1.4 1.3-4.7 1.3Zm-8-4c1.7 0 3 .5 4.4 1a7.8 7.8 0 0 0 6.6.5V4.6a10.3 10.3 0 0 1-7.4-.7C10.4 3.5 9.3 3 8 3c-1.6 0-2.6.3-3 .5v9.9c.7-.2 1.7-.4 3-.4Z" />
    <path d="M4 23a1 1 0 0 1-1-1v-7a1 1 0 0 1 2 0v7c0 .6-.5 1-1 1Z" />
  </Icon>
));
export default FlagIcon;
